package com.iregained.site.components.sections.patients.sections

import androidx.compose.runtime.*
import com.iregained.site.components.sections.product.styles.InvertedCtaButtonStyle
import com.iregained.site.components.widgets.SharedCtaActionLink
import com.iregained.site.components.widgets.SharedCtaWidget
import com.varabyte.kobweb.browser.dom.observers.IntersectionObserver
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.s
import org.jetbrains.compose.web.dom.Div

// UNIQUE ANIMATION: Cinematic Zoom-Out
@Composable
private fun Modifier.cinematicZoomOut(isVisible: Boolean): Modifier {
    return this.opacity(if (isVisible) 1 else 0).scale(if (isVisible) 1f else 1.05f).transition(
            Transition.of("opacity", 1.s, TransitionTimingFunction.EaseOut),
            Transition.of("transform", 1.s, TransitionTimingFunction.EaseOut)
        )
}

@Composable
fun PatientsCtaSection(data: PatientsCtaSectionData = defaultPatientsCtaSectionData) {
    val targetId = data.sectionId?.takeIf { it.isNotBlank() } ?: "patients-cta"
    var isVisible by remember { mutableStateOf(false) }

    if (data.title.isNotBlank()) {
        Div(attrs = Modifier.fillMaxWidth().toAttrs {
            ref { element ->
                val observer = IntersectionObserver { entries, obs ->
                    entries.forEach {
                        if (it.isIntersecting) {
                            isVisible = true; obs.unobserve(element)
                        }
                    }
                }
                observer.observe(element); onDispose { observer.disconnect() }
            }
        }) {
            Box(modifier = Modifier.fillMaxWidth().cinematicZoomOut(isVisible)) {
                SharedCtaWidget(
                    headline = data.title, description = data.subtitle,
                    actions = {
                        if (data.buttonText.isNotBlank() || data.buttonLinkPath.isNotBlank()) {
                            SharedCtaActionLink(
                                text = data.buttonText,
                                path = data.buttonLinkPath,
                                styleModifier = InvertedCtaButtonStyle.toModifier()
                            )
                        }
                    },
                )
            }
        }
    }
}

// ==========================================
// DATA MODELS & CMS
// ==========================================
data class PatientsCtaSectionData(
    val sectionId: String? = null,
    val title: String,
    val subtitle: String,
    val buttonText: String,
    val buttonLinkPath: String
)

val defaultPatientsCtaSectionData = PatientsCtaSectionData(
    sectionId = "patients-cta", title = "Ready to Reclaim Your Independence?", //
    subtitle = "Take the next step in your recovery journey. Contact us to learn more about accessing the MyHand<sup>®</sup> System.", //
    buttonText = "Request a Demo", //
    buttonLinkPath = "/contact#contact-patient-form-section"
)